/**
 * ProductNormalizer — canonical text cleanup for matching and fingerprints.
 */
export class ProductNormalizer {
  normalize(value: string): string {
    return this.collapse(
      this.stripSymbols(
        this.stripAccents(value).toUpperCase().replace(/\s+/g, ' ').trim(),
      ),
    )
  }

  tokenize(value: string): string[] {
    return this.normalize(value)
      .split(/[\s/_+-]+/)
      .map((t) => t.trim())
      .filter(Boolean)
  }

  stripAccents(value: string): string {
    return value.normalize('NFD').replace(/\p{M}/gu, '')
  }

  stripSymbols(value: string): string {
    return value.replace(/[^\p{L}\p{N}\s.\-_/]/gu, ' ')
  }

  collapse(value: string): string {
    return value.replace(/\s+/g, ' ').trim()
  }

  /** Slug for fingerprint segments */
  slug(value: string): string {
    return this.normalize(value)
      .replace(/[^A-Z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
  }
}

export const productNormalizer = new ProductNormalizer()
